import { Resource as a, API as h } from "@coveo/platform-client";
const e = class e extends a {
  create(t, r) {
    return this.api.post(
      this.buildPath(`${e.baseUrl}`, { trackingId: r }),
      t
    );
  }
  list(t) {
    return this.api.get(this.buildPath(`${e.baseUrl}`, t));
  }
  delete(t, r) {
    return this.api.delete(this.buildPath(`${e.baseUrl}/${t}`, { trackingId: r }));
  }
  get(t, r) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/${t}`, { trackingId: r })
    );
  }
  update(t, r, i) {
    return this.api.put(
      this.buildPath(`${e.baseUrl}/${t}`, { trackingId: i }),
      r
    );
  }
};
e.baseUrl = `/rest/organizations/${h.orgPlaceholder}/commerce/v2/search/synonyms`;
let s = e;
export {
  s as Synonyms
};
//# sourceMappingURL=Synonyms.js.map
